import clsx from 'clsx'

import '@hotmart/cosmos/dist/nav/nav.css'
import { NavTabsItem } from './navTabsItem'
import type { NavTabsProps } from './types'

const NavTabs = ({ children, id, className, 'data-test': dataTest }: NavTabsProps) => {
  const classes = clsx('hot-nav--tabs', className)

  return (
    <hot-nav id={id} data-test={dataTest} class={classes}>
      {children}
    </hot-nav>
  )
}

NavTabs.Item = NavTabsItem

export default NavTabs
